import React, { useState, useRef, useEffect } from 'react';
import '../styles/ChannelSelector.css';

const ALL_CHANNEL = { id: 'all', name: 'all', display_name: 'Все', icon: '🗂' };

function ChannelIcon({ icon }) {
  if (icon && /\.(png|jpe?g|webp|ico)$/i.test(icon)) {
    return <img src={'/channel-icons/' + icon} alt="" style={{width:'26px',height:'26px',objectFit:'cover',borderRadius:'3px',verticalAlign:'middle'}} />;
  }
  return <>{icon || '📢'}</>;
}

function ChannelSelector({ channels, selectedChannel, onSelectChannel, unreadCounts = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleChannelSelect = (channel) => {
    onSelectChannel(channel);
    setIsOpen(false);
  };

  const getUnreadCount = (channelId) => {
    const count = unreadCounts.find(c => c.channelId == channelId);
    return count ? count.unreadCount : 0;
  };

  const totalUnread = channels.reduce((sum, ch) => {
    const count = unreadCounts.find(c => c.channelId == ch.id);
    return sum + (count ? count.unreadCount || 0 : 0);
  }, 0);

  if (!selectedChannel) return null;

  const currentUnreadCount = selectedChannel.id === 'all'
    ? totalUnread
    : getUnreadCount(selectedChannel.id);

  const allChannels = [ALL_CHANNEL, ...channels];

  return (
    <div className="channel-selector" ref={dropdownRef}>
      <button
        className="channel-selector-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="channel-icon"><ChannelIcon icon={selectedChannel.icon} /></span>
        <span className="channel-name">{selectedChannel.display_name}</span>
        {currentUnreadCount > 0 && (
          <span className="unread-badge">{currentUnreadCount}</span>
        )}
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="channel-dropdown" onClick={(e) => e.stopPropagation()}>
          {allChannels.map(channel => {
            const unreadCount = channel.id === 'all' ? totalUnread : getUnreadCount(channel.id);
            return (
              <div
                key={channel.id}
                className={`channel-dropdown-item ${selectedChannel.id === channel.id ? 'active' : ''}`}
                onClick={() => handleChannelSelect(channel)}
              >
                <span className="channel-icon"><ChannelIcon icon={channel.icon} /></span>
                <span className="channel-name">{channel.display_name}</span>
                <div className="channel-dropdown-right">
                  {unreadCount > 0 && (
                    <span className="unread-badge">{unreadCount}</span>
                  )}
                  {selectedChannel.id === channel.id && (
                    <span className="check-mark">✓</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ChannelSelector;
